export const pushDataLayer = (event, details = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...details });
};

let leadAttribution = null;

export const getLeadAttribution = () => {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const saved = leadAttribution || {};

  const current = {
    landing_page: saved.landing_page || window.location.href,
    referrer: saved.referrer || document.referrer || "direct",
    utm_source: params.get("utm_source") || saved.utm_source || "",
    utm_medium: params.get("utm_medium") || saved.utm_medium || "",
    utm_campaign: params.get("utm_campaign") || saved.utm_campaign || "",
    utm_term: params.get("utm_term") || saved.utm_term || "",
    utm_content: params.get("utm_content") || saved.utm_content || "",
    gclid: params.get("gclid") || saved.gclid || "",
    gbraid: params.get("gbraid") || saved.gbraid || "",
    wbraid: params.get("wbraid") || saved.wbraid || "",
    source: params.get("source") || saved.source || "",
  };

  // Dane pozostają wyłącznie w pamięci otwartej strony. Są przekazywane
  // Serce Finansów dopiero wtedy, gdy użytkownik sam wyśle formularz.
  leadAttribution = current;

  return current;
};

export const resetLeadAttribution = () => {
  leadAttribution = null;
};
